export default __webpack_public_path__ + "static/media/BrotherhoodofIron.5a14cecc.png";